// src/utils/tempStore.ts
import { EmployeeDetails } from "../components/PayslipForm";

// This object lives in the browser's RAM.
// It survives page changes (React Router).
// It gets DELETED when you Refresh the page.
export const tempStore = {
  details: undefined as EmployeeDetails | undefined,
  letterhead: null as string | null,
  signature: null as string | null,
  primaryColor: "#2563eb",
  contentMargin: 40,
   signaturePadding: 20
};

export const updateTempStore = (
  details: EmployeeDetails,
  letterhead: string | null,
  signature: string | null,
  primaryColor: string,
  contentMargin: number,
  signaturePadding: number
) => {
  tempStore.details = details;
  tempStore.letterhead = letterhead;
  tempStore.signature = signature;
  tempStore.primaryColor = primaryColor;
  tempStore.contentMargin = contentMargin;
  tempStore.signaturePadding = signaturePadding;
};